import { TypeOf, ZodType } from 'zod';

import {
  DeepPartial,
  Path,
  useForm,
  UseFormProps,
  UseFormReturn,
} from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { get } from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAppForm = <T extends ZodType<any>>(
  schema: T,
  {
    mode = 'onTouched',
    criteriaMode = 'all',
    defaultValues,
    ...options
  }: Omit<UseFormProps<T>, 'resolver' | 'defaultValues'> & {
    defaultValues?: DeepPartial<TypeOf<T>>;
  } = {},
): UseFormReturn<TypeOf<T>> & { setDirty: (name: Path<TypeOf<T>>) => void } => {
  const retVal = useForm<TypeOf<T>>({
    resolver: zodResolver(schema),
    mode,
    criteriaMode,
    defaultValues,
    ...options,
  });

  return {
    ...retVal,
    setDirty: (name: Path<TypeOf<T>>) => {
      retVal.setValue(name, get(retVal.getValues(), name), {
        shouldDirty: true,
        shouldValidate: true,
      });
    },
  };
};
